import { functionCallerInstallCommands } from "@p0security/shared/integrations/resources/aws/policy/function-caller";
import { arnInfo } from "@p0security/shared/integrations/resources/aws/util";
import Link from "antd/lib/typography/Link";

import { AwsInstaller } from "../types";

const functionCallerInstructions: AwsInstaller["function-caller"]["instructions"] =
  (context, id) => {
    const info = arnInfo(id);
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using{" "}
          <Link
            href={`https://${info.accountId}.signin.aws.amazon.com/console`}
            target="_blank"
            rel="noopener"
          >
            AWS Cloud Shell
          </Link>{" "}
          or Terraform:
        </>
      ),
      commands: {
        // TODO: Add IAC commands
        shell: [
          {
            command: functionCallerInstallCommands(context, {
              gcloudServiceAccountId: context.config.base[id]?.serviceAccountId,
              lambdaArn: id,
            }),
          },
        ],
      },
    };
  };

export const awsFunctionCallerInstaller: AwsInstaller["function-caller"] = {
  items: {},
  instructions: functionCallerInstructions,
};
